export default __webpack_public_path__ + "static/media/resourceelumnt1.e5e11568.jpg";